import { Button, Col, Container, Form, Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';

import t from '../../../text';
import { NewsletterHOC, NewsletterProps } from './NewsletterHOC';

export const Newsletter = ({ success, validated, handleSubmit, fName, setFName, email, setEmail, message }) => (
  <Container className="py-3 newsletter" id="newsletter">
    <h2 className="title mb-0 text-center mb-3">{t('footer.newsletter.title')}</h2>

    <Form className="w-100" noValidate validated={validated} onSubmit={handleSubmit}>
      {!success && (
        <Row className="row-gap-3 justify-content-center align-items-stretch custom-gutter-10">
          <Col xs={12} md="auto">
            <Form.Group controlId="FirstName">
              <Form.Control
                value={fName}
                onChange={(e) => setFName(e.target.value)}
                type="text"
                placeholder="First name"
                className="border"
                required
              />
              <Form.Control.Feedback type="invalid">{t('footer.newsletter.invalidFirstName')}</Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col xs={12} md="auto">
            <Form.Group controlId="EmailAddress">
              <Form.Control
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                type="email"
                placeholder="Email address"
                className="border"
                required
              />
              <Form.Control.Feedback type="invalid">{t('footer.newsletter.invalidEmail')}</Form.Control.Feedback>
            </Form.Group>
          </Col>

          <Col xs={12} md="auto">
            <Button block variant="primary-yellow" type="submit" className="submit-button">
              {t('footer.newsletter.subscribe')}
            </Button>
          </Col>
        </Row>
      )}
      {message.length > 0 && (
        <Form.Row className="mt-3">
          <Col className="d-flex align-items-baseline gap-1 justify-content-start justify-content-md-center">
            <i className="icon-attention h4 mb-0" />
            <span className="mb-0 text-dark">{message}</span>
          </Col>
        </Form.Row>
      )}
    </Form>

    {!success && (
      <Row className="justify-content-center mt-3">
        <Col xs="auto">
          <p className="text-center mb-0 terms-apply">
            <Link to="/terms">
              <u>{t('footer.newsletter.termsApply')}</u>
            </Link>
          </p>
        </Col>
      </Row>
    )}

    {success && (
      <p className="text-center success-message">
        <i className="icon-check text-success circle-white" /> {t('footer.newsletter.success')}
      </p>
    )}
  </Container>
);

export default NewsletterHOC(Newsletter);

Newsletter.propTypes = NewsletterProps;
